import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { platformServicesMasterActions } from '../../store/reducers/platform-master';
import MasterComponent from '../../common/MasterComponent';
import AddPlatform from './addPlatform';
import Popup from '../../components/Popup';
import { useNavigate, useOutletContext } from 'react-router-dom';
import useNotification from '../../common/notification';
import { defaultFields } from './form';
import { Stack, Tooltip, Typography,useTheme } from '@mui/material';
import { GridValueGetterParams } from '@mui/x-data-grid';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { ServicesDataRequestPayloadTypes } from '../../store/models/platform-master';
import { get } from 'lodash';
import { palette } from '../../theme/palette';

import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as CheckCircleIcon } from '../../assets/icons/main/check-circle-icon.svg';

interface PlatformServicesMasterTypes {
  isPlatformServicesMasterDataLoading: boolean;
  platformServicesMasterData: Array<any>;
  platformServicesMasterDataTotalCount: number;
  platformServicesMasterDataPageNumber: number;
  isAddServiceSuccess: boolean;
  isRemoveServiceSuccess: boolean;
  isUpdateServiceSuccess: boolean;
  isAddServiceError: boolean;
  isUpdateServiceError: boolean;
  isRemoveServiceError: boolean;
  platformMessage: string;
  platformServicesMasterError: boolean;
  searchItem: string;
}

const PlatformServicesMaster = ({
  isPlatformServicesMasterDataLoading,
  platformServicesMasterData,
  platformServicesMasterDataTotalCount,
  platformServicesMasterDataPageNumber,
  isAddServiceSuccess,
  isRemoveServiceSuccess,
  isUpdateServiceSuccess,
  isAddServiceError,
  isUpdateServiceError,
  isRemoveServiceError,
  platformMessage,
  platformServicesMasterError,
  searchItem,
}: PlatformServicesMasterTypes) => {
  const dispatch = useDispatch();
  const [msg, sendNotification] = useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceData, setServiceData] = useState<any>(defaultFields);
  const [isEdit, setIsEdit] = useState(false);
  const [platformMasterData, setPlatformMasterData] = useState<any>([]);
  const [confirmPopup, setConfirmPopup] = useState<any>(false);
  const [openAddPopup, setAddPopup] = useState<any>(false);
  const Navigate = useNavigate();

  const dispatchServicesDataRequest = (payload: ServicesDataRequestPayloadTypes) => {
    dispatch(
      platformServicesMasterActions.getServicesDataRequest({
        search_item: searchItem,
        ...payload,
      })
    );
  };

  useEffect(() => {
    dispatchServicesDataRequest({
      limit: DEFAULT_PAGE_SIZE,
      page: DEFAULT_PAGE_NUMBER,
    });

    return () => {
      dispatch(platformServicesMasterActions.resetPlatformServicesMasterData());
    };
  }, []);

  useEffect(() => {
    if (isAddServiceSuccess || isRemoveServiceSuccess || isUpdateServiceSuccess) {
      dispatchServicesDataRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isRemoveServiceSuccess && platformMasterData.length === 1 && platformServicesMasterDataPageNumber !== 1
            ? platformServicesMasterDataPageNumber - 1
            : platformServicesMasterDataPageNumber,
      });
    }
  }, [isAddServiceSuccess, isRemoveServiceSuccess, isUpdateServiceSuccess]);

  useEffect(() => {
    if (platformServicesMasterData && platformServicesMasterData.length > 0) {
      setPlatformMasterData(
        platformServicesMasterData.map((item: any) => {
          return { ...item, id: item.service_id };
        })
      );
    } else {
      setPlatformMasterData([]);
    }
  }, [platformServicesMasterData]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setServiceData({ ...serviceData, [name]: name === 'port' ? parseInt(value) : value });
  };

  const onCheckItem = (e: any, value: any) => {
    const { types } = serviceData;
    setServiceData((prevItem: any) => {
      return {
        ...prevItem,
        types: types.includes(value) ? types.filter((x: any) => x !== value) : [...types, value],
      };
    });
  };

  const handleEdit = (payload: any) => {
    setIsEdit(true);
    if (payload.types == null) {
      payload.types = [];
    }
    setServiceData(payload);
    setIsModalOpen(true);
  };

  const handleDelete = (payload: any) => {
    setServiceData(payload);
    setConfirmPopup(true);
    //dispatch(platformServicesMasterActions.removeServiceRequest(payload));
  };

  const handleActions = (data: any, type: any) => {
    if (type === 'confirm') {
      dispatch(platformServicesMasterActions.removeServiceRequest(serviceData));
      setServiceData(defaultFields);
      setConfirmPopup(false);
    } else if (type === 'warning') {
      setServiceData(defaultFields);
      setConfirmPopup(false);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setServiceData(defaultFields);
  };

  const clodeAlertModal = () => {
    setAddPopup(false);
    dispatch(platformServicesMasterActions.resetLoadingState());
  };

  const renderFormModal = () => (
    <AddPlatform
      isOpen={isModalOpen}
      serviceData={serviceData}
      setServiceData={setServiceData}
      isEdit={isEdit}
      handleChange={handleChange}
      onCheckItem={onCheckItem}
      handleClose={handleClose}
    />
  );

  const renderAlertModal = () => (
    <Popup
      title='Success'
      open={openAddPopup}
      icon={<SuccessIcon  style={{ color: palette.success.dark }} />}
      message='New Service added Do you want to add a component for this service?'
      confirmation
      confirmLabel='Add Component'
      onConfirm={clodeAlertModal}
      cancel
      cancelLabel='No'
      onCancel={clodeAlertModal}
      onClose={clodeAlertModal}
    />
  );

  const successAlertModal = () => {
    Navigate('/component');
  };

  const customTheme = useTheme();
  const columns: any = [
    {
      field: 'service_name',
      headerName: 'Display name',
      flex: 1,
      minWidth: 200,
      // sortable: false,
      renderCell: (params: any) => {
        return (
          <Tooltip title={params.value} placement='bottom' arrow>
            <Typography
              component='p'
              variant='subtitle1'
              sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
            >
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'key',
      headerName: 'Key',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      // sortable: false,
    },
    {
      field: 'port',
      headerName: 'Port',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      // sortable: false,
    },
    {
      field: 'types',
      headerName: 'Global',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      renderCell: (params: any) => {
        return <CheckCircleIcon style={{ height: '24px', width: '24px', marginLeft: '1.4rem' ,color: palette.success.dark  }} />;
      },
      minWidth: 100,
    },
  ];

  return (
    <>
      <MasterComponent
        heading='List of Services'
        isLoading={isPlatformServicesMasterDataLoading}
        rows={platformMasterData}
        columns={columns}
        isServerPagination
        totalRowCount={platformServicesMasterDataTotalCount}
        pageNumber={platformServicesMasterDataPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchServicesDataRequest({
            limit: pageSize,
            page: pageNumber,
          });
        }}
        setIsModalOpen={setIsModalOpen}
        noRowsOverlay={() => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            Service data not available
          </Stack>
        )}
        actionsColumn={{
          edit: {
            onClick: (params: GridValueGetterParams) => handleEdit(params.row),
          },
          delete: {
            onClick: (params: GridValueGetterParams) => handleDelete(params.row),
          },
        }}
        showSearch
        searchPlaceholder='Service Name / Key / Port'
        onSearch={(searchValue: string) => {
          dispatchServicesDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            search_item: searchValue,
          });
          dispatch(platformServicesMasterActions.onSearchForItem(searchValue));
        }}
      />
      <Popup
        open={confirmPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message='Are you sure to delete this platform?'
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handleActions({}, 'confirm')}
        onClose={() => handleActions({}, 'warning')}
        onCancel={() => handleActions({}, 'warning')}
      />
      {isModalOpen && renderFormModal()}
      {/*<Popup*/}
      {/*  title="Success"*/}
      {/*  open={openAddPopup}*/}
      {/*  icon={<SuccessIcon />}*/}
      {/*  message="New Service added Do you want to add a component for this service?"*/}
      {/*  confirmation*/}
      {/*  confirmLabel="Add Component"*/}
      {/*  onConfirm={successAlertModal}*/}
      {/*  cancel*/}
      {/*  cancelLabel="No"*/}
      {/*  onCancel={clodeAlertModal}*/}
      {/*  onClose={clodeAlertModal}*/}
      {/*/>*/}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  isPlatformServicesMasterDataLoading: state.platformServicesMaster.isPlatformServicesMasterDataLoading,
  platformServicesMasterData: state.platformServicesMaster.platformServicesMasterData,
  platformServicesMasterDataTotalCount: state.platformServicesMaster.platformServicesMasterDataTotalCount,
  platformServicesMasterDataPageNumber: state.platformServicesMaster.platformServicesMasterDataPageNumber,
  isAddServiceSuccess: state.platformServicesMaster.isAddServiceSuccess,
  isRemoveServiceSuccess: state.platformServicesMaster.isRemoveServiceSuccess,
  isUpdateServiceSuccess: state.platformServicesMaster.isUpdateServiceSuccess,
  isAddServiceError: state.platformServicesMaster.isAddServiceError,
  isUpdateServiceError: state.platformServicesMaster.isUpdateServiceError,
  isRemoveServiceError: state.platformServicesMaster.isRemoveServiceError,
  platformServicesMasterError: state.platformServicesMaster.platformServicesMasterError,
  platformMessage: state.platformServicesMaster.platformMessage,
  searchItem: state.platformServicesMaster.searchItem,
});

export default connect(mapStateToProps)(PlatformServicesMaster);
